<template>
  <div class="tab-item steps row">
      <div class="col-lg-2 col-sm-2 iconleft"> 
          <div class="counter">{{index + 1}}</div>
      </div>
      <div class="col-lg-10 col-sm-10">
          <div class="content">
            <h1>{{ step.title }}</h1>
            <p><span style="white-space: pre-wrap; overflow-wrap: break-word">{{step.description}}</span></p>
          </div>
      </div>
  </div>
</template>

<script>
export default {
  name: "RecipeStep",
  props: {
    index: Number,
    step: Object,
  },
};
</script>




// WEBPACK FOOTER //
// src/components/recipes/RecipeStep.vue